import {configureLogger} from "@neuronsearchlab/sdk";

// Enable verbose NeuronSearchLab SDK logging for debugging/troubleshooting.
configureLogger({
  level: "TRACE",
  enableNetworkBodyLogging: true,
  enablePerformanceLogging: true,
});
